const GelProximityPickupDetails = "gelProximityPickupDetails";
const GelProximityBtn = "gelProximityBtn";
const GelProximityPickupError = "gelProximityPickupError";

function getElementById(element: string): HTMLElement {
  const error = document.getElementById(element);
  if (!error) {
    throw new Error(`Element with ID "${element}" not found.`);
  }
  return error;
}

export {
  GelProximityPickupDetails,
  GelProximityBtn,
  GelProximityPickupError,
  getElementById,
};
